import { BETA_INDSTOCKS_HOST, INDSTOCKS_HOST } from '@/root/constants/common'

export const isStocksFunnel = (host?: string) => {
  if (host) {
    return !!(host === INDSTOCKS_HOST || host === BETA_INDSTOCKS_HOST)
  }

  // Will work on client side only as window is used
  return !!(
    window.location.host === INDSTOCKS_HOST ||
    window.location.host === BETA_INDSTOCKS_HOST
  )
}
